<template>
  <div class="new_order_item">
    <div class="package-select">
      <div class="form-group select optional inline">
        <label class="select optional control-label">
          {{ $t('formPackage.package') }}
        </label>

        <select
          id="vue_package_id"
          v-model="selectedPackage"
          :class="[packages.length < 2 ? 'single_item' : '', 'select', 'optional', 'form-control']"
          @change="resetPackageQty()"
        >
          <option
            v-for="pack in packages"
            :key="pack.id"
            :value="pack"
            v-text="packText(pack)"
          />
        </select>
      </div>
    </div>

    <div class="quantity-select">
      <div class="form-group select required inline">
        <label>
          {{ packageInventoryText }}
        </label>

        <select
          id="bottom_form_customer_qty"
          v-model="packageQty"
          class="select required inline quantity form-control"
          @change="emitPackageQty()"
        >
          <option
            v-for="n in packageInventory"
            :key="n"
            :value="n"
          >
            {{ n }}
          </option>
        </select>
      </div>
    </div>
  </div>
</template>

<script>
import { CurrencyApi } from '../../../default/currency_convert'

export default {

  props: {
    packages: {
      default: [],
      required: true
    },

    currency: {
      default: 'USD',
      required: true,
      type: String
    },

    rate: {
      default: 1.0,
      required: true,
      type: Number
    }
  },

  data() {
    return {
      packageQty: 1,
      selectedPackage: null
    }
  },

  computed: {
    packageInventory() {
      if (this.selectedPackage && this.selectedPackage.inventory_on_site < 1) {
        return 0
      } else if (this.selectedPackage) {
        return Math.min(this.selectedPackage.inventory_on_site, 10)
      } else {
        return 1
      }
    },

    packageInventoryText() {
      return this.$t('formPackage.numberOfPeople')
    },

    maxPackageQty() {
      return Math.min(this.selectedPackage.inventory_on_site, 10)
    },
  },

  watch: {
    packages() {
      this.refreshPackages()
    }
  },

  created() {
    this.packages.sort(this.compareByPosition)
    this.refreshPackages()
  },

  methods: {
    emitPackageQty() {
      this.$emit('qty-emit', this.packageQty)
    },

    packText(pack) {
      if (pack == null) { return }

      let name = pack.display_name

      if (pack.price > 0 && !pack.hide_pricing) {
        name = name + ' (' + CurrencyApi.formatAmount(pack.price * this.rate, this.currency) + ')'
      }

      return name
    },

    compareByPosition(a, b){
      if (a.position > b.position) { return 1 }
      if (b.position > a.position) { return -1 }
    },

    refreshPackages() {
      this.selectedPackage = this.packages[0]
      this.resetPackageQty()
    },

    resetPackageQty() {
      this.$emit('package-emit', this.selectedPackage)
      if (this.selectedPackage.inventory_on_site < this.qtyPackage) {
        this.packageQty = 1
        this.emitPackageQty()
      }
    }
  }
}
</script>
